module.exports = __webpack_public_path__ + "static/media/fi.b48413be.svg";